import { useState } from 'react';
import { UTCTimestamp } from 'lightweight-charts';
import Link from 'next/link';
import { IoArrowForward } from 'react-icons/io5';
import { useLocalStorage } from 'usehooks-ts';
import { useSession } from '@/contexts/LitSessionProvider';
import MobileNav from './MobileNav';
import PriceHeader from './PriceHeader';
import MobileTopNav from '@/components/shared/TopNav/MobileTopNav';
import useERC20Balance, { IUserERC20Balance } from '@/hooks/portfolio/useERC20Balance';
import Loading from '@/components/shared/Loading';
import MobileMenu from '@/components/shared/MobileMenu';
import { ResolutionData, resolutionData } from '@/lib/tradingview/chartData';
import PortfolioChart, { CurrentPrice } from '@/components/charts/PortfolioChart';
import AssetsPortfolio from '@/components/assets/AssetsPortfolio';
const TotalPortfolioLink = ({
  assetData,
  currentPrice,
  currentResolution
}: {
  assetData: IUserERC20Balance;
  currentPrice: CurrentPrice;
  currentResolution: ResolutionData;
}) => {
  return <div className='flex items-center w-full justify-between' data-sentry-component="TotalPortfolioLink" data-sentry-source-file="MobileHomePage.tsx">
      <Link href='/overview' data-sentry-element="Link" data-sentry-source-file="MobileHomePage.tsx">
        <PriceHeader currentResolution={currentResolution} currentPrice={currentPrice} assetData={assetData} data-sentry-element="PriceHeader" data-sentry-source-file="MobileHomePage.tsx" />
      </Link>
      <Link href='/overview' data-sentry-element="Link" data-sentry-source-file="MobileHomePage.tsx">
        <IoArrowForward className='w-[18px] h-[18px] text-genius-cream/50 mr-2' data-sentry-element="IoArrowForward" data-sentry-source-file="MobileHomePage.tsx" />
      </Link>
    </div>;
};
export default function MobileHomePage({
  className
}: {
  className?: string;
}) {
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: isLoadingAssetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const [currentPrice, setCurrentPrice] = useLocalStorage<CurrentPrice>('currentPrice', null);
  const [currentResolution, setCurrentResolution] = useState(resolutionData[0]);
  const handleChangeChart = (value: number, beforeValue: number, timestamp: UTCTimestamp) => {
    setCurrentPrice({
      value: value,
      before: beforeValue,
      time: timestamp
    });
  };
  return <div className={`bg-genius-indigo ${className}`} data-sentry-component="MobileHomePage" data-sentry-source-file="MobileHomePage.tsx">
      <MobileTopNav className='static' data-sentry-element="MobileTopNav" data-sentry-source-file="MobileHomePage.tsx" />
      <div className='flex items-center  md:hover:bg-genius-blue mx-4 rounded-lg mb-4'>
        {isLoadingAssetData ? <Loading className='p-4 h-6 w-6 my-1' /> : <>
            <TotalPortfolioLink currentPrice={currentPrice} currentResolution={currentResolution} assetData={assetData} />
          </>}
      </div>
      <MobileNav data-sentry-element="MobileNav" data-sentry-source-file="MobileHomePage.tsx" />
      <div className='w-full homepage-chart'>
        <PortfolioChart onValueChange={handleChangeChart} setCurrentPrice={setCurrentPrice} currentResolution={currentResolution} setCurrentResolution={setCurrentResolution} assetData={assetData} data-sentry-element="PortfolioChart" data-sentry-source-file="MobileHomePage.tsx" />
      </div>
      <div className='mt-6'>
        <AssetsPortfolio isSwap={false} showBreakDown={true} data-sentry-element="AssetsPortfolio" data-sentry-source-file="MobileHomePage.tsx" />
      </div>
      <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="MobileHomePage.tsx" />
    </div>;
}